<template>
  <div class="home">
    <h1>Login</h1>
    <div class="description text-secondary mb-3">
      Dastland games administrator login page.
    </div>

    <!-- Image placeholder -->
    <svg
      class="card-img-top mb-4"
      width="638"
      height="638"
      xmlns="http://www.w3.org/2000/svg"
      v-show="!imageUrlLoaded"
    >
      <rect
        x="0"
        y="0"
        width="638"
        height="638"
        fill="none"
        stroke="gray"
        stroke-width="1"
      />
    </svg>

    <!-- Image -->
    <img
      class="card-img-top mb-4"
      :src="imageUrl"
      @load="imageUrlLoaded = true"
    />

    <DadminLogin />
    <TeoInfo />
  </div>
</template>

<script>
import TeoInfo from "../TeoInfo.vue";
import DadminLogin from "../DadminLogin.vue";

const cmdImageHome = "images.get.preview.tag/home";

export default {
  name: "PageHome",
  components: {
    TeoInfo,
    DadminLogin,
  },

  data() {
    return {
      imageUrl: "https://dadmin.teonet.dev/api/v1/images.get.preview.tag.img/home",
      imageUrlLoaded: false,
    };
  },

  mounted() {
    // this.getImageUrl();
  },

  methods: {
    getImageUrl() {
      this.sendCmd(cmdImageHome).then(
        // Process success answer
        (data) => {
          this.imageUrl = data;
          console.debug("cmdImageHome:", data);
        },
        // Process an error
        (err) => console.error("cmdImageHome error:", err)
      );
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.description {
  font-size: small;
}
.home {
  max-width: 638px;
}

svg {
  width: auto;
  height: auto;
  max-width: 100%;
}
</style>
